import App from '@/App';
import EventPage from '@/pages/event/EventPage';
import FacilityPage from '@/pages/facility/FacilityPage';
import FAQPage from '@/pages/faq/FAQPage';
import FloorGuidePage from '@/pages/floor-guide/FloorGuidePage';
import FNBPage from '@/pages/fnb/FNBPage';
import HomePage from '@/pages/home/HomePage';
import ParkingPage from '@/pages/parking/ParkingPage';
import ShopPage from '@/pages/shop/ShopPage';
import TourGuidePage from '@/pages/tour-guide/TourGuidePage';
import { PATHS } from '@/router/paths';
import type { RouteObject } from 'react-router-dom';
import { Navigate, createBrowserRouter } from 'react-router-dom';

const routes: RouteObject[] = [
    {
        element: <App />,
        children: [
            {
                path: PATHS.INDEX,
                children: [
                    { index: true, element: <Navigate to={PATHS.HOME.INDEX} replace /> },
                    {
                        path: PATHS.HOME.INDEX,
                        children: [{ index: true, element: <HomePage />, handle: { fullWidth: true } }],
                    },
                    {
                        path: PATHS.FLOOR_GUIDE.INDEX,
                        children: [{ index: true, element: <FloorGuidePage /> }],
                    },
                    {
                        path: PATHS.SHOP.INDEX,
                        children: [{ index: true, element: <ShopPage /> }],
                    },
                    {
                        path: PATHS.FNB.INDEX,
                        children: [{ index: true, element: <FNBPage /> }],
                    },
                    {
                        path: PATHS.EVENTS.INDEX,
                        children: [{ index: true, element: <EventPage /> }],
                    },
                    {
                        path: PATHS.PARKING.INDEX,
                        children: [{ index: true, element: <ParkingPage /> }],
                    },
                    {
                        path: PATHS.FACILITY.INDEX,
                        children: [{ index: true, element: <FacilityPage /> }],
                    },
                    {
                        path: PATHS.FAQ.INDEX,
                        children: [{ index: true, element: <FAQPage /> }],
                    },
                    {
                        path: PATHS.TOUR_GUIDE.INDEX,
                        children: [{ index: true, element: <TourGuidePage /> }],
                    },
                ],
            },
            { path: '*', element: <Navigate to={PATHS.HOME.INDEX} replace /> },
        ],
    },
];

export const router = createBrowserRouter(routes);
export default routes;
